<template>
  <div class="personal-information">
    <!-- MAIN_INFO -->
    <md-card class="card-content">
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title text-lg">{{ $t("student.main_information") }}</h4>
        </div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout mt-15">
          <!-- USERNAME -->
          <div
            class="md-layout-item md-size-33 md-small-size-100"
            :class="styleErrorServer('username')"
          >
            <validation-field
              :validations="validationsStudent.username"
              :field-class="getValidationClass('username')"
              name="username"
            >
              <label>{{ $t("common.username") }}</label>
              <md-input
                required
                v-model.trim="form.username"
                :disabled="isEdit"
                autocomplete="off"
              ></md-input>
              <span class="md-error" v-if="serverValidations.username">{{
                serverValidations.username
              }}</span>
            </validation-field>
          </div>
          <!-- USERNAME -->

          <!-- PASSWORD -->
          <div
            class="md-layout-item md-size-33 md-small-size-100"
            :class="styleErrorServer('password')"
            v-if="!isEdit"
          >
            <validation-field
              :validations="validationsStudent.password"
              :field-class="getValidationClass('password')"
              name="password"
            >
              <label>{{ $t("common.password") }}</label>
              <md-input
                required
                type="password"
                v-model.trim="form.password"
                autocomplete="off"
              ></md-input>
              <span class="md-error" v-if="serverValidations.password">{{
                serverValidations.password
              }}</span>
            </validation-field>
          </div>
          <!-- PASSWORD -->

          <!-- STATUS -->
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>{{ $t("common.status") }}</label>
              <md-select
                name="status"
                id="personal-status"
                v-model="form.status"
                :disabled="isEdit && !canEdit"
              >
                <md-option value="Active">{{ $t("common.active") }}</md-option>
                <md-option value="Inactive"
                  >{{ $t("common.inactive") }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <!-- STATUS -->

          <!-- STUDENT ID -->
          <div
            class="md-layout-item md-size-33 md-small-size-100"
            v-if="isEdit"
          >
            <md-field>
              <label>{{ $t("common.student_id") }}</label>
              <md-input v-model.trim="form.student_code" disabled></md-input>
            </md-field>
          </div>
          <!-- STUDENT ID -->

          <!-- FIRSTNAME -->
          <div
            class="md-layout-item md-size-33 md-small-size-100"
            :class="styleErrorServer('first_name')"
          >
            <validation-field
              :validations="validationsStudent.first_name"
              :field-class="getValidationClass('first_name')"
              name="first name"
            >
              <label>{{ $t("common.first_name") }}</label>
              <md-input
                required
                v-model.trim="form.first_name"
                :disabled="isFamilyRole"
              ></md-input>
              <span class="md-error" v-if="serverValidations.first_name">{{
                serverValidations.first_name
              }}</span>
            </validation-field>
          </div>
          <!-- FIRSTNAME -->

          <!-- MIDDLE_NAME -->
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>{{ $t("common.middle_name") }}</label>
              <md-input
                v-model.trim="form.middle_name"
                :disabled="isFamilyRole"
              ></md-input>
            </md-field>
          </div>
          <!-- MIDDLE_NAME -->

          <!-- LASTNAME -->
          <div class="md-layout-item md-size-33 md-small-size-100">
            <validation-field
              :validations="validationsStudent.last_name"
              :field-class="getValidationClass('last_name')"
              name="last name"
            >
              <label>{{ $t("common.last_name") }}</label>
              <md-input
                required
                v-model.trim="form.last_name"
                :disabled="isFamilyRole"
              ></md-input>
            </validation-field>
          </div>
          <!-- LASTNAME -->

          <!-- PHONE_NUMBER -->
          <div class="md-layout-item md-size-33 md-small-size-100">
            <validation-field
              :validations="validationsStudent.phone_number"
              name="phone number"
            >
              <label>{{ $t("common.phone_number") }}</label>
              <md-input v-model.trim="form.phone_number"></md-input>
              <span class="md-error" v-if="serverValidations.phone_number">{{
                serverValidations.phone_number
              }}</span>
            </validation-field>
          </div>
          <!-- PHONE_NUMBER -->

          <!-- EMAIL -->
          <div
            class="md-layout-item md-size-33 md-small-size-100"
            :class="styleErrorServer('email')"
          >
            <validation-field
              :validations="validationsStudent.email"
              :field-class="getValidationClass('email')"
              name="email"
            >
              <label>{{ $t("common.email") }}</label>
              <md-input
                required
                v-model.trim="form.email"
                :disabled="isEdit && !canEdit"
              ></md-input>
              <span class="md-error" v-if="serverValidations.email">{{
                serverValidations.email
              }}</span>
            </validation-field>
          </div>
          <!-- EMAIL -->

          <!-- NATIONALITY -->
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-autocomplete
              v-model="form.nationality"
              :md-options="NATIONALITIES"
              :disabled="isFamilyRole"
            >
              <label>{{ $t("student.nationality") }}</label>
            </md-autocomplete>
          </div>
          <!-- NATIONALITY -->

          <!-- Sex -->
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>{{ $t("common.sex") }}</label>
              <md-select name="sex" id="personal-gender" v-model="form.sex">
                <md-option value="Male">{{ $t("student.male") }}</md-option>
                <md-option value="Female">{{ $t("student.female") }}</md-option>
                <md-option value="Other">{{ $t("common.other") }}</md-option>
              </md-select>
            </md-field>
          </div>
          <!-- Sex -->

          <!-- BIRTHDAY -->
          <div class="md-layout-item md-size-33 md-small-size-100 mb-4">
            <validation-field
              :validations="validationsStudent.birthday"
              name="birthday"
              type="date-picker"
            >
              <template #default="{ errors }">
                <date-picker-custom
                  :label="$t('common.birthday')"
                  v-model="form.birthday"
                >
                  <span class="md-error">{{ errors[0] }}</span>
                </date-picker-custom>
              </template>
            </validation-field>
          </div>
          <!-- BIRTHDAY -->
        </div>
      </md-card-content>
    </md-card>
    <!-- MAIN_INFO -->

    <!-- ACADEMIC -->
    <md-card class="card-content mt-14">
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title text-lg">{{ $t("student.academic") }}</h4>
        </div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout mt-15">
          <div class="md-layout-item md-size-20 md-small-size-100">
            <validation-field
              :validations="{ required: true }"
              name="school year"
            >
              <label>{{ $t("student.school_year") }}</label>
              <md-select
                name="school_year"
                id="school_year"
                v-model="form.school_year"
                required
                :disabled="isFamilyRole"
              >
                <md-option
                  v-for="item in schoolYears"
                  :value="item.id"
                  :key="'school year' + item.id"
                  >{{ item.name }}
                </md-option>
              </md-select>
            </validation-field>
          </div>

          <!-- Entered -->
          <div class="md-layout-item md-size-20 md-small-size-100">
            <date-picker-custom
              :label="$t('student.entered')"
              v-model="form.entered"
              :disabled="isEdit && !canEdit"
            ></date-picker-custom>
          </div>
          <!-- Entered -->

          <!-- Graduation -->
          <div class="md-layout-item md-size-20 md-small-size-100">
            <date-picker-custom
              :label="$t('student.graduation')"
              v-model="form.graduation"
              :disabled="isEdit && !canEdit"
            ></date-picker-custom>
          </div>
          <!-- Graduation -->

          <!-- Grade with Division -->
          <div class="md-layout-item md-size-20 md-small-size-100">
            <md-field>
              <label>{{ $t("common.grade") }}</label>
              <md-select
                name="grade"
                id="grade"
                v-model="form.grade"
                :disabled="isFamilyRole"
              >
                <md-option
                  v-for="grade in gradeOptions"
                  :value="grade.name"
                  :key="grade.id + grade.name"
                  >{{ grade.name }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-20 md-small-size-100">
            <md-field>
              <label>{{ $t("student.division") }}</label>
              <md-input
                v-model.trim="form.division"
                :disabled="isFamilyRole"
              ></md-input>
            </md-field>
          </div>
          <!-- Grade with Division -->

          <!-- Entry reason -->
          <div class="md-layout-item md-size-60 md-small-size-100">
            <md-field>
              <label>{{ $t("student.entry_reason") }}</label>
              <md-textarea
                :value="generateEntryReason(form.entry_reason)"
                md-autogrow
                v-if="isEdit && !canEdit"
                :disabled="isFamilyRole"
              ></md-textarea>
              <md-select
                v-else
                name="entry-reason"
                id="entry-reason"
                v-model="form.entry_reason"
                :disabled="isFamilyRole"
              >
                <md-option
                  v-for="entryReason in ENTRY_REASONS"
                  :key="entryReason"
                  :value="entryReason"
                >
                  {{ generateEntryReason(entryReason) }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <!-- Entry reason -->

          <!-- Program -->
          <div class="md-layout-item md-size-40 md-small-size-100">
            <md-field v-if="isEdit && !canEdit">
              <label>{{ $t("student.program") }}</label>
              <md-input
                v-model="selectedProgramName"
                disabled
                class="truncate"
              ></md-input>
            </md-field>
            <checkbox-multi-select
              v-else
              :label="selectProgram.label"
              :options="selectProgram.options"
              :trackBy="selectProgram.trackBy"
              :displayField="selectProgram.displayField"
              :style="{ marginTop: '-6px' }"
              v-model="form.program_ids"
            >
            </checkbox-multi-select>
          </div>
          <!-- Program -->

          <!-- Withdraw -->
          <div
            class="md-layout-item md-size-30 md-small-size-100"
            v-if="isEdit"
          >
            <date-picker-custom
              :label="$t('student.withdraw')"
              v-model="form.withdraw"
              :disabled="!canEdit"
            ></date-picker-custom>
          </div>
          <!-- Withdraw -->

          <!-- Withdraw Code -->
          <div
            class="md-layout-item md-size-30 md-small-size-100"
            v-if="isEdit"
          >
            <md-field>
              <label>{{ $t("student.withdraw_code") }}</label>
              <md-input
                v-model.trim="form.withdraw_code"
                :disabled="isFamilyRole"
              ></md-input>
            </md-field>
          </div>
          <!-- Withdraw code -->

          <!-- Counselor -->
          <div
            class="md-layout-item md-size-40 md-small-size-100"
            v-if="isEdit"
          >
            <md-field>
              <label>{{ $t("student.counselor") }}</label>
              <md-input
                v-model="form.counselor"
                disabled
                class="truncate"
              ></md-input>
            </md-field>
          </div>
          <!-- Counselor -->
        </div>
      </md-card-content>
    </md-card>
    <!-- ACADEMIC -->

    <!-- CERTIFICATE -->
    <certificate
      :isEditPage="isEdit && !isFamilyRole"
      ref="certificateRef"
    ></certificate>
    <!-- CERTIFICATE -->

    <!-- ADDRESS -->
    <md-card class="card-content mt-14">
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title text-lg">{{ $t("student.address") }}</h4>
        </div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout mt-15">
          <!-- Primary address -->
          <div class="md-layout-item md-size-100 mb-2">
            <h6 class="title text-md font-semibold normal-case">
              {{ $t("student.primary_address") }}
            </h6>
          </div>

          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>{{ $t("student.street") }}</label>
              <md-input v-model.trim="form.primary_street"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>{{ $t("student.apartment") }}</label>
              <md-input v-model.trim="form.primary_apartment"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>{{ $t("student.city") }}</label>
              <md-input v-model.trim="form.primary_city"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-33 md-small-size-100">
            <isis-autocomplete
              :label="$t('common.country')"
              v-model="primaryAddress.country.displayValue"
              :value.sync="primaryAddress.country.value"
              :options="countryOptions"
              :refetchOptions="
                queryObj =>
                  getCountries(
                    primaryAddress.country.value,
                    queryObj.search_key
                  )
              "
              :searchKey="primaryAddress.country.searchKey"
              :fields="primaryAddress.country.fields"
              fetchOnOpen
            >
            </isis-autocomplete>
          </div>

          <div class="md-layout-item md-size-33 md-small-size-100">
            <isis-autocomplete
              :label="$t('student.state')"
              v-model="primaryAddress.state.displayValue"
              :value.sync="primaryAddress.state.value"
              :options="stateOptions"
              :refetchOptions="
                queryObj =>
                  getStates(primaryAddress.country.value, queryObj.search_key)
              "
              :searchKey="primaryAddress.state.searchKey"
              :fields="primaryAddress.state.fields"
              :isDisabled="!primaryAddress.country.value"
              fetchOnOpen
            >
            </isis-autocomplete>
          </div>

          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>{{ $t("student.zip") }}</label>
              <md-input v-model.trim="form.primary_zip"></md-input>
            </md-field>
          </div>
          <!-- Primary address -->

          <!-- Secondary address -->
          <div class="md-layout-item md-size-100 mt-8 mb-2">
            <h6 class="title text-md font-semibold normal-case">
              {{ $t("student.secondary_address") }}
            </h6>
          </div>

          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>{{ $t("student.street") }}</label>
              <md-input v-model.trim="form.secondary_street"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>{{ $t("student.apartment") }}</label>
              <md-input v-model.trim="form.secondary_apartment"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>{{ $t("student.city") }}</label>
              <md-input v-model.trim="form.secondary_city"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-33 md-small-size-100">
            <isis-autocomplete
              :label="$t('common.country')"
              v-model="secondaryAddress.country.displayValue"
              :value.sync="secondaryAddress.country.value"
              :options="countryOptions"
              :refetchOptions="
                queryObj =>
                  getCountries(
                    secondaryAddress.country.value,
                    queryObj.search_key
                  )
              "
              :searchKey="secondaryAddress.country.searchKey"
              :fields="secondaryAddress.country.fields"
              fetchOnOpen
            >
            </isis-autocomplete>
          </div>

          <div class="md-layout-item md-size-33 md-small-size-100">
            <isis-autocomplete
              :label="$t('student.state')"
              v-model="secondaryAddress.state.displayValue"
              :value.sync="secondaryAddress.state.value"
              :options="stateOptions"
              :refetchOptions="
                queryObj =>
                  getStates(secondaryAddress.country.value, queryObj.search_key)
              "
              :searchKey="secondaryAddress.state.searchKey"
              :fields="secondaryAddress.state.fields"
              :isDisabled="!secondaryAddress.country.value"
              fetchOnOpen
            >
            </isis-autocomplete>
          </div>

          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>{{ $t("student.zip") }}</label>
              <md-input v-model.trim="form.secondary_zip"></md-input>
            </md-field>
          </div>
          <!-- Secondary address -->
        </div>
      </md-card-content>
    </md-card>
    <!-- ADDRESS -->

    <!-- FAMILY INFORMATION -->
    <md-card class="card-content mt-14" v-if="isEdit">
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title text-lg">{{ $t("student.family_information") }}</h4>
        </div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout mt-15">
          <div class="md-layout-item md-size-100 mb-4">
            <Family ref="familyContact" :canEdit="canEdit"></Family>
          </div>

          <!-- Dwelling type -->
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>{{ $t("student.dwelling_type") }}</label>
              <md-textarea
                :value="generateDwellingType(form.dwelling_type)"
                md-autogrow
                v-if="!canEdit"
                :disabled="isFamilyRole"
              ></md-textarea>
              <md-select
                v-else
                name="dwelling_type"
                id="dwelling_type"
                v-model="form.dwelling_type"
                :disabled="isFamilyRole"
              >
                <md-option
                  v-for="dwellingType in DWELLING_TYPES"
                  :value="dwellingType"
                  :key="dwellingType"
                  >{{ generateDwellingType(dwellingType) }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <!-- Dwelling type -->

          <!-- Parents status -->
          <div class="md-layout-item md-size-100 md:flex items-center">
            <p class="question">{{ $t("student.are_parents_divorced") }}</p>
            <div class="md:ml-4 answers">
              <md-radio
                v-model="form.parent_divorced"
                value="yes"
                :disabled="isFamilyRole"
                >{{ $t("common.yes") }}
              </md-radio>
              <md-radio
                v-model="form.parent_divorced"
                value="no"
                :disabled="isFamilyRole"
                >{{ $t("common.no") }}
              </md-radio>
            </div>
          </div>
          <!-- Parents status -->

          <!-- Siblings and contact -->
          <div class="md-layout-item md-size-100">
            <p>
              <b class="font-bold">{{ $t("student.siblings_and_contact") }}</b>
              <span class="text-xs">
                {{ $t("student.no_fullname_age_phone_number_email") }}</span
              >
            </p>
            <md-field class="sibling-desc border border-gray-300 p-2">
              <md-textarea
                placeholder="1.Anne Smith- 21 years old- 0967888999- hoangnga@gmail.com"
                class="isis-textarea p-0"
                v-model="form.siblings_contact"
                :disabled="isFamilyRole"
              ></md-textarea>
            </md-field>
          </div>
          <!-- Siblings and contact -->
        </div>
      </md-card-content>
    </md-card>
    <!-- FAMILY INFORMATION -->
  </div>
</template>

<script>
import nationalities from "@/helpers/nationalities";
import { getId, getPieceObj } from "@/helpers/utils";
import { service_names, service_paths } from "@/constants/Services";
import { validations } from "@/validations/students";
import Certificate from "./Certificates";
import { DWELLING_TYPES, ENTRY_REASONS } from "@/pages/Students/data";
import Family from "../Family";
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect.vue";
import Role from "@/constants/Role";
import { Student } from "@/constants/Permissions";
import { mapGetters, mapState } from "vuex";
import { hasValidRole, isDynamicRole } from "@/helpers/role-helper";
import {
  generateDwellingType,
  generateEntryReason
} from "@/helpers/text-helper";
import { SCHOOL_YEARS } from "../../../../constants";

export default {
  name: "student-personal-information",
  props: ["path", "isEdit", "serverValidations"],
  components: { Family, Certificate, CheckboxMultiSelect },
  data() {
    const initialFormData = {
      username: null,
      password: null,
      status: "Active",
      first_name: null,
      middle_name: null,
      last_name: null,
      full_name: null,
      birthday: null,
      email: null,
      phone_number: null,
      nationality: null,
      sex: null,
      student_code: null,
      entered: null,
      withdraw: null,
      withdraw_code: null,
      graduation: null,
      grade: null,
      division: null,
      entry_reason: null,
      primary_street: null,
      primary_apartment: null,
      primary_state: null,
      primary_city: null,
      primary_zip: null,
      primary_country: null,
      secondary_street: null,
      secondary_apartment: null,
      secondary_state: null,
      secondary_city: null,
      secondary_zip: null,
      secondary_country: null,
      certificates: [],
      counselor: [],
      dwelling_type: null,
      parent_divorced: null,
      siblings_contact: null,
      program_ids: [],
      school_year: null
    };
    return {
      NATIONALITIES: nationalities,
      gradeOptions: [],
      ENTRY_REASONS,
      generateEntryReason,
      form: initialFormData,
      validationsStudent: validations,
      DWELLING_TYPES,
      generateDwellingType,
      selectProgram: {
        label: "student.select_programs",
        name: "program",
        value: [],
        type: "checkbox-multi-select",
        options: [],
        trackBy: "id",
        displayField: "name"
      },
      selectedProgramName: [],
      Role,
      Student,
      schoolYears: SCHOOL_YEARS,
      primaryAddress: {
        country: {
          value: "",
          displayValue: "",
          fields: {
            text: "name",
            value: "two_code"
          },
          searchKey: "search_key"
        },
        state: {
          value: "",
          displayValue: "",
          fields: {
            text: "name",
            value: "name"
          },
          searchKey: "search_key"
        }
      },
      secondaryAddress: {
        country: {
          value: "",
          displayValue: "",
          fields: {
            text: "name",
            value: "two_code"
          },
          searchKey: "search_key"
        },
        state: {
          value: "",
          displayValue: "",
          fields: {
            text: "name",
            value: "name"
          },
          searchKey: "search_key"
        }
      },
      countryOptions: [],
      stateOptions: []
    };
  },
  computed: {
    ...mapState("user", ["info"]),
    ...mapGetters("user", ["role"]),

    canEdit() {
      return (
        hasValidRole(this.role, [Role.Admin, Role.Principal]) ||
        (isDynamicRole(this.info, this.role) &&
          this.$can(Student.actions.edit, Student.subject))
      );
    },
    isFamilyRole() {
      return hasValidRole(this.role, [Role.Family]);
    }
  },
  watch: {
    "form.username": function() {
      this.serverValidations.username && delete this.serverValidations.username;
    },

    "form.email": function() {
      this.serverValidations.email && delete this.serverValidations.email;
    },

    "form.phone_number": function() {
      this.serverValidations.phone_number &&
        delete this.serverValidations.phone_number;
    },

    "form.first_name": function() {
      this.serverValidations.first_name &&
        delete this.serverValidations.first_name;
    },

    "form.last_name": function() {
      this.serverValidations.last_name &&
        delete this.serverValidations.last_name;
    },

    "primaryAddress.country.displayValue"(newCountry) {
      if (!newCountry) {
        this.primaryAddress.state.displayValue = "";
        this.primaryAddress.state.value = "";
      }
      this.form.primary_country = newCountry;
    },

    "primaryAddress.state.displayValue"(newState) {
      this.form.primary_state = newState;
    },

    "secondaryAddress.country.displayValue"(newCountry) {
      if (!newCountry) {
        this.secondaryAddress.state.displayValue = "";
        this.secondaryAddress.state.value = "";
      }
      this.form.secondary_country = newCountry;
    },

    "secondaryAddress.state.displayValue"(newState) {
      this.form.secondary_state = newState;
    }
  },
  created() {
    this.getGradeOptions();
    this.getSchoolYearOptions();
    if (!this.isEdit) {
      this.fetchListProgram();
    }
  },
  methods: {
    getCountries(selectedValue, searchKey) {
      return this.$axios
        .get(
          `${service_names.user}/countries`,
          {
            "name__~": searchKey
          },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.countryOptions = data.data;
        });
    },
    getStates(countryCode, searchKey) {
      return this.$axios
        .get(
          `${service_names.user}/states`,
          {
            country_code: countryCode,
            "name__~": searchKey
          },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.stateOptions = data.data;
        });
    },
    async getFormData() {
      // Certificate: upload file
      await this.$refs.certificateRef.getFormData();
      this.form.certificates = this.$refs.certificateRef.formattedForm;
      return this.form;
    },
    getValidationClass(fieldName) {
      return {
        "md-invalid": !!this.serverValidations[fieldName]
      };
    },
    styleErrorServer(fieldName) {
      return {
        "mb-20": !!this.serverValidations[fieldName]
      };
    },
    async loadData(data) {
      this.$refs.familyContact.fetchDataFamily(data._id);
      await this.fetchListProgram();
      const newFormData = getPieceObj(this.form, data);
      this.form = Object.assign({}, this.form, newFormData);
      if (this.isEdit) {
        this.initAddress();
        let selectedProgram = this.form.program_ids.map(el =>
          this.selectProgram.options.find(option => option.id === el)
        );
        this.selectedProgramName = selectedProgram
          .map(el => el.name)
          .join(", ");
      }

      this.getCounselor(getId(data));
    },
    initAddress() {
      if (this.form.primary_country) {
        this.$axios
          .get(`${service_names.user}/countries`, {
            "name__~": this.form.primary_country
          })
          .then(({ data }) => {
            this.primaryAddress.country.displayValue = data?.data[0].name;
            this.primaryAddress.country.value = data?.data[0].two_code;
          });
      }
      this.primaryAddress.state.displayValue = this.form.primary_state;
      this.primaryAddress.state.value = this.form.primary_state;

      if (this.form.secondary_country) {
        this.$axios
          .get(`${service_names.user}/countries`, {
            "name__~": this.form.secondary_country
          })
          .then(({ data }) => {
            this.secondaryAddress.country.displayValue = data?.data[0].name;
            this.secondaryAddress.country.value = data?.data[0].two_code;
          });
      }
      this.secondaryAddress.state.displayValue = this.form.secondary_state;
      this.secondaryAddress.state.value = this.form.secondary_state;
    },
    getSchoolYearOptions() {
      this.$axios
        .get(`${service_names.user}/school-years`, {
          order_by: "school_year ASC",
          limit: 100
        })
        .then(({ data: resData }) => {
          const years = (resData.data || []).map(item => ({
            id: item.school_year,
            name: item.school_year
          }));
          // keep the built-in list if the collection is empty or unreachable
          if (years.length) this.schoolYears = years;
        })
        .catch(() => {});
    },
    getGradeOptions() {
      this.$axios
        .get(`${service_names.school}/grades`, { limit: 20 })
        .then(({ data: resData }) => {
          this.gradeOptions = [...resData.data];
        });
    },
    getCounselor(id) {
      this.$axios
        .get(
          `${service_paths.students}/${id}/counselors`,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          this.form.counselor = response.data
            .map(counselor => counselor.username)
            .join(", ");
        });
    },
    async fetchListProgram() {
      await this.$axios
        .get(
          service_paths.programs,
          { status: "Active", limit: 100 },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          if (response.data.data) {
            this.selectProgram.options = response.data.data;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
input:disabled,
.md-select.md-disabled {
  background: rgba(196, 196, 196, 0.3);
}

.md-field {
  margin-bottom: 10px !important;
}

.card-content {
  padding-bottom: 20px;
}

.mb-20 {
  margin-bottom: 20px !important;
}

.md-error {
  top: 40px;
}

.md-card {
  box-shadow: 0 1px 4px 0 #49494980;

  & ~ .md-card {
    margin-top: 50px;
  }
}
</style>

<style lang="scss">
.md-field.md-clearable .md-input {
  padding-right: 0 !important;
}
</style>
